export const SCHEDULE_GET         = "SCHEDULE_GET"
export const SCHEDULE_SET         = "SCHEDULE_SET"
